export * from "./libs/process-environment";
export * from "./libs/unified-latex-process-environment";

// NOTE: The docstring comment must be the last item in the index.ts file!
/**
 * ## What is this?
 *
 * Functions to report on/manipulate environments in a `unified-latex` Abstract Syntax Tree (AST).
 *
 * ## When should I use this?
 *
 * If you are working on the internals of `unified-latex-util-parse` or need to make a custom parser
 * that treats environments differently.
 */
